import { ItemStatusCode, ItemStatusLabel } from './redpim.enum'

export type Category = {
	id: string // db id
	pimId: string //cat id
	descriptionsIntl: TranslatedField
	nameIntl: TranslatedField
	headersIntl: TranslatedField
	brand: string
	parentCategory: Category | null
	thumbnail: string
}

export type Product = {
	id: string
	pimId: string
	nameIntl: TranslatedField
	shortDescriptionIntl: null | TranslatedField
	descriptionIntl: null | TranslatedField
	specifications?: Specification[]
	specificationFilters?: SpecificationFilter[]
	thumbnail?: string
	brand: string
	benefitsIntl: null | TranslatedField[]
	sloganIntl: null | TranslatedField
	industryTags: null | Array<string>
	uspIntl: null | TranslatedField
	category?: Category
	items?: Item[]
	itemCount?: number
	activeItemCount?: number
}

export type Item = {
	partnumber: string
	model: string
	descriptionsIntl?: { [key: string]: string }
	shortDescriptionsIntl?: { [key: string]: string }
	specifications: Specification[]
	specificationBlocks?: SpecificationBlocks
	product?: string
	category?: Category
	thumbnail?: string
	images?: Image[]
	marketingDescriptionsIntl: { [key: string]: string }
	countriesRestrictedIn?: string
	replacementMaterial?: string
	statusLabel?: ItemStatusLabel
	statusCode?: ItemStatusCode
}

export type RequestDetails = {
	brand: string
	from: number
	to: number
	items: number
	total: number
	category: number
}

export enum Languages {
	Czech = 'cs_CZ',
	German_DE = 'de_DE',
	English_GB = 'en_GB',
	English_US = 'en_US',
	Spanish_ES = 'es_ES',
	Spanish_MX = 'es_MX',
	French_CA = 'fr_CA',
	French_FR = 'fr_FR',
	Hungrian = 'hu_HU',
	Italian_IT = 'it_IT',
	Japanese = 'ja_JP',
	Korean = 'ko_KR',
	Dutch_NL = 'nl_NL',
	Polish = 'pl_PL',
	Portuguese_BR = 'pt_BR',
	Portuguese_PT = 'pt_PT',
	Romanian = 'ro_RO',
	Slovak = 'sk_SK',
	Slovenian = 'sl_SI',
	SwedishEN = 'en_SE',
	Turkish = 'tr_TR',
	Chinese = 'zh_CN',
	SouthAfricanEN = 'en_ZA',
	IndianEN = 'en_IN',
	ThaiEN = 'en_TH',
}

export type TranslatedField = {
	[key in Languages]?: string
}

export type Specification = {
	nameIntl: TranslatedField
	index: number
	unitCategory: 'Metric' | 'Imperial' | 'Universal'
	specFieldTypeId: null | string
	value: string
	unit: string
	specificationId: string
	attributeId: string
	dataType: string
}

export type SpecificationFilter = {
	attributeId: string
	index: number
	nameIntl: TranslatedField
	unitCategory: 'Metric' | 'Imperial' | 'Universal'
	FieldTypeIds: string[]
}

export type SpecificationBlocks = {
	Metric: { [key: string]: string }
	Universal: { [key: string]: string }
	Imperial: { [key: string]: string }
}

export type Image = {
	url: string
	name: string
	description: string
}

export enum DocumentCategory {
	cadFiles,
	userManuals,
	safetyInstructions,
	complianceCertificates,
	explodedViews,
}
